import React from 'react';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';

import { FDataGrid, FGridMoneyCell, FGridPercentCell } from '../grid';
import { IAllocationLink } from './budgetallocation.models';

type Props = {
  rows: IAllocationLink[];
  selection: GridRowSelectionModel;
  loading?: boolean;
  onSelectionChange: (selection: GridRowSelectionModel) => void;
};

class BudgetAllocationLinksGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'activity_code', headerName: 'Activity', width: 140 },
    { field: 'activity_name', headerName: 'Activity Name', flex: 1, minWidth: 280 },
    { field: 'lineitem_code', headerName: 'Line Item', width: 140 },
    { field: 'lineitem_name', headerName: 'Line Item Name', flex: 1, minWidth: 280 },
    { field: 'allocationratio', headerName: 'Ratio', width: 110, renderCell: FGridPercentCell },
    { field: 'allocatedamount', headerName: 'Amount', width: 150, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Current Activity Budget Links"
        subtitle="Existing mappings between activities and budget line items."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={420}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#f6efe8' }}
        getRowId={(row: any) => row.recid || row.id}
        checkboxSelection
        rowSelectionModel={this.props.selection}
        onRowSelectionModelChange={this.props.onSelectionChange}
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
      />
    );
  }
}

export default BudgetAllocationLinksGrid;
